import { useState, createElement, useEffect } from 'react';
import './index.scss';
const ColorfulCountdown = ({ seconds = 60, hasUnit = false, fontColor = 'black', fontSize = 16, backgroundColor = 'white', content = '点击开始倒计时', children, }) => {
    const [count, setCount] = useState(0);
    const countDownStyles = {
        color: fontColor,
        fontSize: `${fontSize}px`,
        backgroundColor,
    };
    useEffect(() => {
        if (count > 0) {
            const timer = setTimeout(() => setCount(count - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [count]);
    const handleClick = (e) => {
        count === 0 && setCount(seconds);
    };
    const innerCon = (createElement(React.Fragment, null, children || createElement("div", { className: "countdown-inner", style: countDownStyles }, content)));
    return (createElement("div", { className: "au-countdown", onClick: handleClick }, count > 0 ? createElement("div", { className: "countdown-inner", style: countDownStyles }, `倒计时: ${count} ${hasUnit || '秒'}`) : innerCon));
};
ColorfulCountdown.displayName = 'ColorfulCountdown';
export default ColorfulCountdown;
